export enum RecordType {
  products = 'products',
  productGroups = 'productGroups',
  customerGroups = 'customerGroups',
  customers = 'customers'
}
